import { render, staticRenderFns } from "./fwShipFrame.vue?vue&type=template&id=ec403a6c&"
import script from "./fwShipFrame.vue?vue&type=script&lang=js&"
export * from "./fwShipFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports